import { Grid2 as Grid } from '@mui/material';
import { useGetDashboardData } from '../../hooks';
import { CONTEXT, PAYMENT_CARD_TYPES } from '../../../../config/consts/commons';
import { MetricGrid, PerformanceGrid, DetailsGrid } from './cards';
import { COUNTRIES } from '@wareclouds/frontend-common';
import { DashboardEmptyState } from './states';
import { BonusAlert } from './alerts';

const isBr = CONTEXT === COUNTRIES.BR;

export default function SemiMonthlySummaryDashboard(props) {
  const { period, serviceName } = props;

  const { dashboardData, isLoadingData, isErrorData, bonus } =
    useGetDashboardData({
      period,
      serviceName,
    });

  const metricData = dashboardData.filter(
    (item) => item.type === PAYMENT_CARD_TYPES.METRIC && item.show
  );

  const performanceData = dashboardData.filter(
    (item) => item.type === PAYMENT_CARD_TYPES.PERFORMANCE && item.show
  );

  const detailsData = dashboardData.filter(
    (item) => item.type === PAYMENT_CARD_TYPES.DETAILS && item.show
  );

  if (
    (!isLoadingData && dashboardData.length === 0 && !period) ||
    isErrorData
  ) {
    return <DashboardEmptyState />;
  }

  return (
    <Grid container spacing={{ xs: 2, sm: 3 }}>
      {bonus?.current > 0 && (
        <Grid size={12}>
          <BonusAlert amount={bonus.current} />
        </Grid>
      )}

      <MetricGrid metricData={metricData} isLoading={isLoadingData} />

      <Grid
        container
        flexDirection={isBr ? 'column-reverse' : 'column'}
        spacing={2}
        size={12}
      >
        <PerformanceGrid
          performanceData={performanceData}
          isLoading={isLoadingData}
        />

        <DetailsGrid detailsData={detailsData} isLoading={isLoadingData} />
      </Grid>
    </Grid>
  );
}
